/**
 * The visible form of "we do not know". Three states must stay distinguishable
 * on screen: a real value, a genuine zero, and this.
 *
 * ⛔ Do not add a placeholder number, an average, or an industry typical value.
 * That is the defect this component exists to replace.
 */
export function NotMeasured({ needs }: { needs: string }) {
  return (
    <div className="not-measured">
      <span className="not-measured__value" aria-hidden="true">——</span>
      <span className="not-measured__label">Not calculated</span>
      <span className="not-measured__reason">Needs: {needs} — not yet reported by this client</span>
    </div>
  );
}
